function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("path", {
  id: "prefix__a",
  d: "M0 0L124 0 124 124 0 124z"
}), React.createElement("path", {
  id: "prefix__c",
  d: "M0.191 0.079L21.975 0.079 21.975 20.872 0.191 20.872z"
}), React.createElement("path", {
  id: "prefix__e",
  d: "M0 124L125 124 125 0 0 0z"
}));

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("mask", {
  id: "prefix__b",
  fill: "#fff"
}, React.createElement("use", {
  xlinkHref: "#prefix__a"
})), React.createElement("path", {
  fill: "#3FBACF",
  d: "M124 62c0 34.242-27.758 62-62 62-34.242 0-62-27.758-62-62C0 27.758 27.758 0 62 0c34.242 0 62 27.758 62 62",
  mask: "url(#prefix__b)"
}), React.createElement("path", {
  fill: "#F4E6A3",
  d: "M99 62c0 19.882-16.118 36-36 36S27 81.882 27 62s16.118-36 36-36 36 16.118 36 36"
}), React.createElement("path", {
  fill: "#F7F3EF",
  d: "M116 89c0 9.941-8.059 18-18 18s-18-8.059-18-18 8.059-18 18-18 18 8.059 18 18"
}), React.createElement("g", {
  transform: "translate(103 86)"
}, React.createElement("mask", {
  id: "prefix__d",
  fill: "#fff"
}, React.createElement("use", {
  xlinkHref: "#prefix__c"
})), React.createElement("path", {
  fill: "#F7F3EF",
  d: "M21.975 10.476c0 5.741-4.877 10.396-10.892 10.396S.191 16.217.191 10.476C.191 4.734 5.068.079 11.083.079s10.892 4.655 10.892 10.397",
  mask: "url(#prefix__d)"
})), React.createElement("path", {
  fill: "#F7F3EF",
  d: "M93 94.5c0 6.351-5.149 11.5-11.5 11.5S70 100.851 70 94.5 75.149 83 81.5 83 93 88.149 93 94.5"
}), React.createElement("mask", {
  id: "prefix__f",
  fill: "#fff"
}, React.createElement("use", {
  xlinkHref: "#prefix__e"
})), React.createElement("path", {
  fill: "#F7F3EF",
  d: "M78 106L116 106 116 94 78 94z",
  mask: "url(#prefix__f)"
}));

var SvgHumidity = function SvgHumidity(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 125,
    height: 124,
    viewBox: "0 0 125 124",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgHumidity, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/humidity.9ba5cdf4.svg";
export { ForwardRef as ReactComponent };